/**
 * Copiare negli appunti, anche dove l'API moderna non c'e'.
 *
 * `navigator.clipboard` esiste solo in contesto sicuro e in alcune viste web
 * native non c'e' affatto; senza una via di riserva il tasto "copia" sarebbe
 * uno di quei bottoni che non fanno niente e non lo dicono. La riserva e' il
 * vecchio trucco: una textarea fuori schermo, si seleziona, si esegue copy.
 *
 * Restituisce true se il testo e' davvero finito negli appunti, cosi' chi
 * chiama puo' dire com'e' andata invece di far finta.
 */
export async function copiaTesto(testo: string): Promise<boolean> {
  const t = (testo ?? "").trim();
  if (!t) return false;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(t);
      return true;
    }
  } catch {
    // permesso negato o contesto non sicuro: si prova la via vecchia
  }

  try {
    const area = document.createElement("textarea");
    area.value = t;
    // fuori dallo schermo ma non display:none, altrimenti non e' selezionabile;
    // readOnly evita che su iOS salti su la tastiera per un istante.
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.top = "-1000px";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    area.setSelectionRange(0, t.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}
